import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=25c7bb7a&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"
import style0 from "./commission.vue?vue&type=style&index=0&id=25c7bb7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7bb7a",
  null
  
)

export default component.exports